import { FoxBizRequest, FoxRestBizClient } from "@/api/client";
import { menuManagement } from "@/modules/menu-management.js";
import axios from "axios";
import {reactive} from "@vue/reactivity";
import {ref} from "vue";

/**
 * 공통 기능 클래스
 */
class Common {

    /**
     * 생성자
     */
    constructor() {
    }

    /**
     * 암호화, 복호화 키 조회 메서드
     */
    getSirenPhoneSecString() {
        return new Promise((resolve, reject) => {

            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Common.Biz.CommonBiz';
            request.methodId = 'GetSirenPhoneSecString';

            service.execute(request).then(response => {

                const reqInfo = response;

                if (!!reqInfo) resolve(reqInfo);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 암호화 -> 복호화 메서드
     * @param {String} requestNum 
     * @param {String} resulttInfo 
     * @returns 
     */
     setSirenPhoneSecString(requestNum, resulttInfo) {
        return new Promise((resolve, reject) => {

            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Common.Biz.CommonBiz';
            request.methodId = 'SetSirenPhoneSecString';
            request.parameters.requestNum = requestNum
            request.parameters.resulttInfo = resulttInfo

            service.execute(request).then(response => {

                if (!!response) resolve(response.data.result.value);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 공통 시스템코드 정보 가져오기
     * @param {string} boardInfo 
     * @param {string} searchVal 
     * @returns 
     */
    getSystemCodeInfo(boardInfo, searchVal) {
        return new Promise((resolve, reject) => {

            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Admin.Biz.CodeBiz';
            request.methodId = 'GetCodeInfoByBoardInfo';
            request.parameters.boardInfo = boardInfo
            request.parameters.searchVal = searchVal

            service.execute(request).then(response => {

                const rows = response.data.result.value.Table.rows;

                if (!!rows.length) resolve(rows);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 지원분야 정보 가져오기
     * @param {string} noticeseq  
     * @returns 
     */
    getEKOSRecruitmentPart(noticeseq) {
        return new Promise((resolve, reject) => {

            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Admin.Biz.RecruitBiz';
            request.methodId = 'GetEKOSRecruitmentPart';
            request.parameters.noticeSeq = noticeseq;

            service.execute(request).then(response => {

                const rows = response.data.result.value;

                if (!!rows.length) resolve(rows);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 서브타이틀 및 배경 변경 메서드
     * @param currentPagePath 현재페이지 경로
     * @returns {Object}
     */
    getSubTitleElement(currentPagePath) {

        // 채용 사이트 메뉴 데이터 소스
        const recruitMenu = menuManagement.getMenuDataSource()

        // 3Depth 메뉴정보 설정
        const threeDepthMenuInfo = [...recruitMenu.filter(row => row.path === currentPagePath)]

        // 2Depth 메뉴정보 설정
        const twoDepthMenuInfo = [...recruitMenu.filter(row => (row.menuId === threeDepthMenuInfo[0].parentMenuId))]

        // 1Depth 메뉴정보 설정
        const oneMenuInfo = [...recruitMenu.filter(row => row.menuId === twoDepthMenuInfo[0].parentMenuId)]

        // return 객체 설정
        const subTitleInfo = new Object()

        // 현재 화면에 맞는 서브 타이틀 설정
        subTitleInfo.backGroundStyle = threeDepthMenuInfo[0].backgroundClass;
        subTitleInfo.oneDeptMenuTitle = oneMenuInfo.length === 0 ? twoDepthMenuInfo[0].title : oneMenuInfo[0].title
        subTitleInfo.twoDeptMenuTitle = threeDepthMenuInfo[0].title

        return subTitleInfo
    }

    /**
     * 정보제공 동의여부 조회
     * @param String dic 
     * @returns 
     */
    AgreeOrNot(dic) {
        return new Promise((resolve, reject) => {

            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Recruit.Biz.RecruitBiz';
            request.methodId = 'AgreeOrNot';
            request.parameters.dic = dic;

            service.execute(request).then(response => {
                const rows = response.data.result.value.Table;

                if (!!response) resolve(rows);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 정보제공 동의여부 추가
     * @param String dic 
     * @returns 
    */
    InsertAgree(dic) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Recruit.Biz.RecruitBiz';
            request.methodId = 'InsertAgree';
            request.parameters.dic = dic;

            service.execute(request).then(response => {
                const resultData = response.data.result.value;
                if (!!response) resolve(
                    resultData
                );
                else resolve(null);
            }).catch(error => reject(error));
        });
    }
}

export const common = new Common();
